import React from 'react';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import Card from '../../components/ui/Card';
import { formatarMoeda } from '../../utils/formatters';

export default function GraficoComparativo({ dados }) {
  if (!dados?.length) return null;

  return (
    <Card style={{ marginTop: 20 }}>
      <h3 style={{ fontSize: '0.95rem', fontWeight: 700, marginBottom: 20 }}>📊 Total a Pagar por Banco</h3>
      <ResponsiveContainer width="100%" height={280}>
        <BarChart data={dados}>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" />
          <XAxis dataKey="banco" tick={{ fill: 'var(--text-muted)', fontSize: 12 }} />
          <YAxis
            tick={{ fill: 'var(--text-muted)', fontSize: 11 }}
            tickFormatter={(v) => `R$ ${(v / 1000).toFixed(0)}k`}
          />
          <Tooltip
            contentStyle={{
              background: 'var(--white)',
              border: '1px solid var(--border)',
              borderRadius: 10,
              fontSize: '0.82rem',
              boxShadow: '0 8px 24px rgba(11,29,53,0.08)',
            }}
            formatter={(v) => formatarMoeda(v)}
          />
          <Legend />
          <Bar dataKey="totalJuros" name="Total Juros" fill="var(--rose)" radius={[4, 4, 0, 0]} />
          <Bar dataKey="totalAPagar" name="Total a Pagar" fill="var(--accent)" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </Card>
  );
}